import { render, staticRenderFns } from "./instagram-logs.vue?vue&type=template&id=2de2ad42&"
import script from "./instagram-logs.vue?vue&type=script&lang=js&"
export * from "./instagram-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports